//Node Modules
import { useEffect, useRef } from "react";

//3rd Party Components
import { Chart, registerables } from "chart.js";

//Helpers
import { dashboardBarChartConfig } from "../../config/chart";

//Simple bar chart for dashboard summaries - pass chart.js shaped labels/datasets.
//onBarClick(datasetIndex, index) makes bars clickable (cursor feedback included).
const DashboardBarChart = ({ labels, datasets, stacked = false, onBarClick }) => {
	const canvasRef = useRef(null);
	Chart.register(...registerables);

	useEffect(() => {
		if (!canvasRef.current) return;

		const options = dashboardBarChartConfig(stacked);
		if (onBarClick) {
			options.onClick = (event, elements) => {
				if (elements?.length) onBarClick(elements[0].datasetIndex, elements[0].index);
			};
			options.onHover = (event, elements) => {
				event.native.target.style.cursor = elements?.length ? "pointer" : "default";
			};
		}

		const chart = new Chart(canvasRef.current.getContext("2d"), {
			type: "bar",
			data: { labels, datasets },
			options,
		});

		return () => chart.destroy();
	}, [labels, datasets, stacked, onBarClick]);

	return (
		<div style={{ height: "280px" }}>
			<canvas ref={canvasRef}></canvas>
		</div>
	);
};

export default DashboardBarChart;
